













import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class Tabs extends Vue {
  @Prop({required: true, type: Array}) dataSource!: DataSource[];
  @Prop(String) type!: string;
  @Prop(String) classPrefix?: string;
  @Prop({type: String, default: '64px'}) tabsHeight!: string;

  // 动态设置 li 对应样式
  setLiClass(item: DataSource) {
    return {
      [this.classPrefix + '-tabs-item']: this.classPrefix,
      selected: item.type === this.type
    };
  }

  select(item: DataSource) {
    this.$emit('update:type', item.type);
    this.$store.commit('updateTypeStore', item.type);
  }

  mounted() {
    // 读取session信息 渲染页面
    if (this.$store.state.moneySessionStore.typeStore.length === 0) {
      this.$store.commit('updateTypeStore', '-');
    }
    this.$emit('update:type', this.$store.state.moneySessionStore.typeStore);
  }
}
